import styled from 'styled-components'

import { photoStreamBorderRadius } from 'common/constants'
import { Colors } from 'common-constants/colors'

export const SvgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.invisibleSvgBgColor};
  min-width: 60px;
  max-width: 60px;
  height: 60px;
  ${(props) => props.theme.marginRight}: 10px;

  border-radius: ${photoStreamBorderRadius}px;
  overflow: hidden;
`
